<template>
  <thead>
  <tr>
    <th class="name_col">Name</th>
    <RotatedTh class="ref_col">Payment ref</RotatedTh>
    <RotatedTh class="rate_col">Rate</RotatedTh>
    <RotatedTh class="geo_col">Geo</RotatedTh>
    <RotatedTh class="status_col">Status</RotatedTh>

    <!-- ROTATED DAY HEADERS -->
    <RotatedTh
        v-for="(date, index) in getDatesBetween(start_date, end_date)"
        :key="`hdr-${index}`"
        class="day_col"
        :label="date"
        :width="60"
    />

    <RotatedTh class="checkbox_col">Ending?</RotatedTh>
    <RotatedTh class="checkbox_col">Retention</RotatedTh>
    <th class="total_col">Subtotal</th>
    <th class="total_col">Adjs.</th>
    <th class="total_col">Total</th>
    <th class="button_col"></th>
  </tr>

  <tr>
    <!--<th class="name_col">-->
    <!--  <input-->
    <!--      id="search"-->
    <!--      :value="search"-->
    <!--      class="form-control"-->
    <!--      placeholder="Search by name, role or ID"-->
    <!--      type="text"-->
    <!--      @input="$emit('input', $event.target.value)"-->
    <!--  />-->
    <!--</th>-->

    <th :colspan="(getDatesBetween(start_date, end_date).length ?? 0) + 11"></th>
  </tr>
  </thead>
</template>

<script>
import { getDatesBetween } from '../shared';
import RotatedTh from '../shared/RotatedTh.vue'; // adjust path if needed

export default {
  name: 'TimesheetHeader',

  components: {
    RotatedTh,
  },

  model: {
    prop: 'search',
    event: 'input',
  },

  props: {
    search: { type: String, default: '' },
    start_date: { type: [String, Number, Date, Object], required: true },
    end_date: { type: [String, Number, Date, Object], required: true },
  },

  methods: {
    getDatesBetween,
  },
};
</script>


<style scoped>
@import '../../components/shared/css/workers-table.css';

thead{
  height: 150px;
}

th {
  height: 100%;
  justify-content: center;
  vertical-align: bottom;
}

input {
  width: 100%;
}

</style>

